import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        width: "100%"
    },
    investFormContainer: {
        marginTop: 48,
        flexDirection: 'column',
        alignItems: 'center',
        width: "100%"
    },
    errorsContainer: {
        flexDirection: 'column',
    },
    errorMessage: {
        color: 'red',
        fontSize: 14,
        fontFamily: 'Montserrat',
        marginBottom: 5
    },
    errorMessageTitle: {
        marginBottom: 15,
        fontSize: 18
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'row'
    }
});
